export default "__VITE_ASSET__DEqbIquz__"